var DesktopGeneric = function() {
    return {
        updateMsgCount: function() {
            Ajax.getUserData((res) => {
                if (parseInt(res.msg_count) != 0) {
                    $('.ii__unread_cnt').text(res.msg_count);
                    $('.ii__unread_cnt').show();
                    $('.ii__chat_cnt').hide();
                } else {
                    $('.ii__unread_cnt').hide();
                    $('.ii__chat_cnt').show();
                }
            }).finally(function() {
                setTimeout(DesktopGeneric.updateMsgCount, 20 * 1000);
            });
        },
        init: function() {
            DesktopGeneric.initHeader();
            // textareas
            $('body').on('keyup blur', 'textarea[maxlength]', function() {
                var maxlength = $(this).attr('maxlength');
                var val = $(this).val();
                if (val.length > maxlength) {
                    $(this).val(val.slice(0, maxlength));
                }
            });

            if (Generic.loggedin) {
                setTimeout(DesktopGeneric.updateMsgCount, 20 * 1000);
            }

            // sticky promo
            if (Generic.jsCookies.hasItem('STICKY_ST_COLLAPSED')) {
                $('#windowBox').collapse('hide');
            }
            DesktopGeneric.initStickyBetList();
            $('#sticky-comp-list').show();
        },
        initStickyBetList: function() {
            $('#windowBox').on('hidden.bs.collapse', function() {
                Generic.jsCookies.setItem('STICKY_ST_COLLAPSED', 1, 3600 * 24 * 3, '/');
            });
            $('#windowBox').on('shown.bs.collapse', function() {
                if (Generic.jsCookies.hasItem('STICKY_ST_COLLAPSED')) {
                    Generic.jsCookies.removeItem('STICKY_ST_COLLAPSED', '/');
                }
            });
        },
        initHeader: function() {
            // menu hamburger
            $('.ii__menu_trigger').click(function() {
                let body = $('body');
                if (body.hasClass('menu-on')) {
                    body.removeClass('menu-on').addClass('menu-off');
                } else {
                    body.removeClass('menu-off').addClass('menu-on');
                }
                $('.submenu').removeClass('show');
            });

            // menu open/close on load+resize
            $(window).on('load resize', function(e) {
                var width = $(window).width();
                var mediaQuery = 1330;
                if (width >= mediaQuery){
                    $('body').removeClass('menu-off').addClass('menu-on');
                }
                if (width < mediaQuery){
                    $('body').removeClass('menu-on').addClass('menu-off');
                    $('.submenu').removeClass('show');
                }
            });

            // submenu show/hide
            $('.ii__submenu-trigger').mouseenter(function() {
                var target = $(this).data('submenu');
                var targetSiblings = $(target).siblings();
                $(targetSiblings).removeClass('show');
                $(target).addClass('show');
            });
            $('.menu__list-item:not(.ii__submenu-trigger)').mouseenter(function() {
                $('.submenu').removeClass('show');
            });
            $('.container').mouseenter(function() {
                $('.submenu').removeClass('show');
            });

            // prevent chat dropdown from closing
            $('.dropdown-menu--noclose > *:not(.dropdown-toggle)').on(
                'click', function(event) {
                    event.stopPropagation();
                }
            );
        },
        showAdModal: function() {
            if ($('#splash_stoix').length > 0) {
                $('#splash_stoix').modal();
                return;
            }
            Ajax.getAdModal(function(res) {
                if (res.success == 'ok') {
                    $('body').append(res.html);
                    $('#splash_stoix').modal();
                }
            });
        },
        initAnalyseisBox: function(matchPage) {
            var carouselEntriesCnt = $('.abox__scroller .abox__btn').length;
            var infiniteScrollThreshold = matchPage ? 3 : 2;
            var allowScroll = carouselEntriesCnt > infiniteScrollThreshold;
            $('.js-carousel-abox').slick({
                dots: false,
                infinite: allowScroll,
                slidesToScroll: 1,
                swipe: false,
                variableWidth: true,
                prevArrow: allowScroll ? `<a href="#!" class="slick-arrow slick-arrow--prev">
                    <i class="icon fal fa-angle-left"></i></a>` : null,
                nextArrow: allowScroll ? `<a href="#!" class="slick-arrow slick-arrow--next">
                    <i class="icon fal fa-angle-right"></i></a>` : null,
            });

            $('.abox__btn').on('click', function() {
                var countryId = $(this).data('country-id');
                $('.abox__btn.abox__btn--active').removeClass('abox__btn--active');
                $(this).addClass('abox__btn--active');
                if (countryId == 'all') {
                    $('.abox__card:not(.ii__init_hidden)').show();
                    $('.abox__card.ii__init_hidden').hide();
                    $('#more-analyseis').show();
                    return;
                }
                $('.abox__card').hide();
                $('.abox__card.ii__analysi_country_' + countryId).show();
                $('#more-analyseis').hide();
            });

            $('#more-analyseis').on('click', function() {
                $('.abox__card.ii__init_hidden').removeClass('ii__init_hidden');
                $('.abox__card').show();
                $('#more-analyseis').remove();
            });
        }
    };
}();
